import { render, staticRenderFns } from "./dynamicField.vue?vue&type=template&id=389d11f2"
import script from "./dynamicField.vue?vue&type=script&lang=ts"
export * from "./dynamicField.vue?vue&type=script&lang=ts"
import style0 from "./dynamicField.vue?vue&type=style&index=0&id=389d11f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports